import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Footer } from "./Components/Footer";
import { Header } from "./Components/Header";
import { Home } from "./Components/Home";
import { NotFound } from "./Components/NotFound";
import { useState } from "react";
import CacheBuster from "react-cache-buster";
import packageFile from '../package.json';
import CacheLoading from "./CacheLoading";

function App() {

  const {version} = packageFile;

  const [categoryText, setCategoryText] = useState('Mobile Phones & Accessories');

  const isProduction = process.env.NODE_ENV === 'production';

  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<CacheLoading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
    <div className="wrapper">
      <Header />
      <Router>
        <Routes>
          <Route exact path="/" element={<Home categoryText={categoryText} setCategoryText={setCategoryText} />} />
          <Route path="*" element={<NotFound setCategoryText={setCategoryText} />}/>
        </Routes>
      </Router>
      <Footer/>
    </div>
    </CacheBuster>
  );
}

export default App;
